import { render, staticRenderFns } from "./reports-legend-bar-chart.vue?vue&type=template&id=1ee79c1f&scoped=true"
import script from "./reports-legend-bar-chart.vue?vue&type=script&lang=js"
export * from "./reports-legend-bar-chart.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-bar-chart.vue?vue&type=style&index=0&id=1ee79c1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee79c1f",
  null
  
)

export default component.exports